import {
  doc,
  setDoc,
  serverTimestamp,
  query,
  orderBy,
  collection,
  limit,
  getDocs
} from "firebase/firestore";

import { db } from "../firebase";
import Cookies from "js-cookie";

export const Create_contents = async (data) => {
  const {
    title,
    description,
    keywords,
    pageuid,
    category,
    companyuid,
    contentuid
  } = data || {};

  // ================= VALIDATION =================
  if (!contentuid?.trim()) {
    return { success: false, error: "Missing contentuid" };
  }
  if (!category?.trim()) {
    return { success: false, error: "Missing category" };
  }
  if (!title?.trim()) {
    return { success: false, error: "Missing title" };
  }
  if (!description?.trim()) {
    return { success: false, error: "Missing description" };
  }
  if (!pageuid?.trim()) {
    return { success: false, error: "Missing pageuid" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken || !guid || !companyuid) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  try {
    const servicetablename = "companies";
    const tablename = "contentdata";

    // ✅ CORRECT PATH
    const collectionRef = collection(
      db,
      servicetablename,
      companyuid,
      "pages",
      pageuid,
      tablename
    );

    const docRef = doc(
      db,
      servicetablename,
      companyuid,
      "pages",
      pageuid,
      tablename,
      contentuid
    );

    // ================= INDEX NUMBER =================
    let indexnumber = 1;

    const indexSnap = await getDocs(
      query(collectionRef, orderBy("indexnumber", "desc"), limit(1))
    );

    if (!indexSnap.empty) {
      indexnumber = (indexSnap.docs[0].data().indexnumber || 0) + 1;
    }

    // ================= SAVE =================
    await setDoc(
      docRef,
      {
        ...data, 
        guid, 
        sessiontoken,
        indexnumber,
        update_date_time: serverTimestamp(),
        date_time: serverTimestamp()
      },
      { merge: true }
    );

    return { success: true, contentuid };

  } catch (err) {
    console.error("❌ Error saving content:", err);

    return {
      success: false,
      error: err.message || "Unknown error"
    };
  }
};